import { useStaffGetSpecialConditions } from '@urbanx/agx.campaigns.client'

export const useGetSpecialConditionsInfo = (
  campaignId?: string,
  contractId?: string
) => {
  const { data: specialConditions, isPending: specialConditionsPending } =
    useStaffGetSpecialConditions(campaignId ?? '', contractId, !!campaignId)

  return {
    specialConditions: specialConditions?.specialConditionsData,
    specialConditionIdToClauseNumberMap: specialConditions?.specialConditionIdToClauseNumberMap,
    specialConditionsPending,
  }
}
